<template>
    <div id="app">
        <Authentication v-if="!isAuthenticated"/>
        <Dashboard v-if="isAuthenticated"/>
        <div class="modal" :class="{ 'open' : modalIsOpen}">
            <div class="modal__content">
                <div class="modal__header">
                    <div class="modal__header__logo">
                      <svg  xmlns="http://www.w3.org/2000/svg" id="Calque_1" viewBox="0 0 2458.78 367.71">
                        <path d="M1676.85 367.71c-4.3-2.22-9.18-2.09-13.73-3.4-36.54-10.54-60.93-34.57-73.24-69.71-16.51-47.11-15.02-93.75 11.92-137.12 32.19-51.83 95.14-58.29 134.6-38.5a84.375 84.375 0 0 1 17.76 11.94c5.27 4.61 9.83 9.87 14.66 15.56v-25.57q0-8.35 8.32-8.35c21.32 0 42.64.07 63.96-.07 3.43-.02 4.88.43 4.87 4.48-.14 80.9-.12 161.79-.03 242.69 0 3.37-.7 4.54-4.33 4.51-22.82-.17-45.64-.16-68.46 0-3.51.02-4.5-.94-4.42-4.43.23-9.79.08-19.58.08-29.25-1.04-.63-1.43.08-1.77.55-15.55 21.2-36.63 32.73-62.56 35.84-.57.07-1.09.55-1.63.84h-26Zm91.93-129.46c-.04-6.27-.72-12.38-2-18.41-5.31-25.1-26.16-42.89-51.31-43.8-25.32-.92-47.17 15.11-54.13 40.08-3.87 13.87-3.79 27.97-.46 41.93 9.36 39.2 55.35 55.68 86.12 30.94 16.26-13.07 21.53-30.9 21.77-50.75ZM977.91 367.71c-5.73-2.25-11.91-2.15-17.83-3.57-51.21-12.22-85.83-50.79-92.27-102.89-3.84-31.05-1.26-61.19 13.4-89.33 18.14-34.83 47.72-54.29 85.86-60.81 30.02-5.13 59.52-2.72 87.23 10.92 35.27 17.35 55.21 46.36 62.53 84.47 2.91 15.15 2.67 30.44 1.59 45.77-.29 4.04-1.95 4.61-5.5 4.61-54.49-.1-108.97-.07-163.46-.07-6.41 0-6.45 0-5.61 6.14 4.99 36.17 37.13 48.28 64.57 39.19 9.47-3.14 16.29-9.56 20.94-18.24 1.28-2.39 2.65-3.22 5.37-3.21 24.83.12 49.65.14 74.48 0 3.77-.02 3.99 1.01 2.95 4.25-14.02 43.46-44.12 69.13-87.94 79.77-5.07 1.23-10.43.89-15.31 3.02h-31Zm13.49-153.85c14.66 0 29.32-.18 43.97.11 4.24.08 4.99-1.4 4.58-5.09-1.13-10.34-5.26-19.05-12.96-26.17-21.54-19.91-73.15-18.29-82.7 26.74-.78 3.65-.02 4.52 3.63 4.48 14.49-.18 28.98-.07 43.47-.07Zm1262.4 153.85c-4.7-2.23-9.92-1.88-14.86-2.93-25.58-5.46-48.17-16.18-65.27-36.64-10.4-12.44-16.4-26.81-18.56-42.88-.4-2.97.37-3.7 3.26-3.69 23.16.09 46.32.05 69.47.04 1.89 0 3.58-.14 3.91 2.55 1.6 13.13 14.75 25.05 33.85 26.52 7 .54 13.99.16 20.69-2.31 8.65-3.18 13.62-9.32 13.89-17.05.28-8.22-3.59-13.66-12.93-17.49-15.58-6.39-32.03-9.89-48.27-14.08-11.59-2.99-23.2-6.07-34.11-11.03-19.75-8.98-35.3-22.12-40.06-44.55-7.3-34.43 7.07-64.73 38.44-81.51 23.9-12.78 49.71-15.04 76.15-13.26 13.19.89 26.1 3.45 38.19 8.9 31.67 14.26 48.94 39.22 53.85 73.23.36 2.49-.32 3.19-2.77 3.18-21.82-.07-43.65-.07-65.47 0-2.32 0-2.93-.96-3.49-3.12-3.74-14.49-13.94-23.05-28.92-24.89-7.89-.97-15.64-.81-23.12 2.02-7.08 2.68-11.67 7.47-12.19 15.45-.53 8.2 3.44 13.61 10.51 17.07 10.68 5.23 22.22 7.78 33.67 10.62 16.29 4.04 32.55 8.29 48.05 14.79 25.44 10.67 42.51 28.35 44.95 57.06 2.62 30.76-10.65 53.36-36.89 68.7-14.28 8.35-29.96 12.56-46.35 14.3-1.24.13-2.72-.41-3.64.98h-32Zm-1007.91 0c-6.76-1.33-13.59-2.41-20.28-4.05-27.04-6.62-50.2-19.34-66.07-43.07-7.14-10.68-11.41-22.44-12.85-35.25-.31-2.78.2-3.79 3.22-3.78 23.16.1 46.32.07 69.48.04 1.97 0 3.24.06 3.72 2.66 2.96 16.12 18.01 25.25 33.99 26.42 7.34.54 14.66.19 21.6-2.74 7.64-3.22 12.86-8.46 13.01-17.17.15-8.43-4.87-13.44-12.19-16.53-14.61-6.17-30.04-9.63-45.34-13.48-13.06-3.29-26.16-6.63-38.41-12.24-21.57-9.88-37.13-24.98-40.67-49.8-4.36-30.61 9.22-58.42 36.19-74.19 17.38-10.16 36.37-14.49 56.2-15.43 21.64-1.04 43.01.69 62.99 9.93 30.63 14.16 47.21 38.76 52.28 71.66.45 2.94-.17 4.1-3.52 4.08-21.33-.15-42.66-.09-63.99-.05-1.96 0-3.59 0-4.05-2.49-3.6-19.57-21.82-27.23-40.36-25.94-4.64.32-9.26 1.02-13.52 3.14-6.3 3.12-10.15 7.87-10.5 15.13-.37 7.52 3.13 12.84 9.56 16.16 10.87 5.61 22.76 8.23 34.54 11.13 16.31 4.02 32.59 8.23 48.09 14.75 22.29 9.38 39.1 24.16 43.84 49.14 6.41 33.8-7.38 61.62-38.18 78.1-13.53 7.24-28.08 11.06-43.23 12.87-1.22.15-2.73-.56-3.56 1h-32Z" class="cls-3"/>
                        <path d="M0 175.86c1.85-6.85 2.16-13.97 3.85-20.88 5.32-21.72 15.14-41.05 29.62-58.06 20.54-24.13 46.38-39.39 77.25-46.38 10.11-2.29 20.38-3.29 30.63-3.33 57.16-.24 114.32-.07 171.47-.21 4.24-.01 5.28 1.25 5.24 5.34-.21 17.98-.24 35.97.01 53.95.06 4.37-1.05 5.6-5.52 5.58-56.99-.16-113.99.4-170.97-.3-32.26-.4-62.23 20.51-72.9 49.98-2.57 7.1-3.88 14.45-4.45 21.86-.31 4.07-1.95 4.41-5.25 4.4-19.66-.08-39.33.01-58.99.04v-11.99Zm0 124.9c58.49 0 116.98-.25 175.46.09 36.93.22 68.29-24.95 75.9-59.9.85-3.88 1.9-7.79 1.57-11.79-.31-3.63 1.23-4.43 4.6-4.4 18.33.14 36.66.14 54.99 0 3.35-.02 4.68.72 4.57 4.41-1.04 32.79-12.27 61.59-33.54 86.49-21.05 24.65-47.64 40-79.37 46.47-7.64 1.56-15.38 2.6-23.23 2.6-60.32-.03-120.64-.02-180.96-.02v-63.95Z" style="fill:#9dafdc"/>
                        <path d="M2458.78 53.96c-2.17 3-2.24 6.76-3.68 10.06-8.26 18.97-27.88 29.37-48.57 25.54-20.51-3.8-34.91-20.24-35.78-40.85-1.07-25.44 10.98-41.73 35.47-47.98.24-.06.38-.48.57-.73h16c.29 1.06 1.21.86 1.98 1.04 16.27 3.78 26.7 13.85 32.05 29.53.72 2.12.25 4.61 1.97 6.41v16.99Zm-44.14 30.08c22.11.02 37.77-15.99 37.94-38.78.16-22.59-15.66-39.16-37.51-39.26-22.47-.11-38.07 15.88-38.07 39.01 0 22.81 15.63 39.01 37.65 39.02ZM406.51 205.92c0-50.94.05-101.88-.09-152.82-.01-4.22.81-5.64 5.39-5.61 44.31.31 88.63.02 132.93.64 18.61.26 36.54 4.84 53.18 13.64 31.86 16.85 47.35 44.11 49.93 79.27 1.53 20.84-2 40.84-12.63 59.1-15 25.78-38.37 39.86-66.74 46.58-12.04 2.85-24.33 3.76-36.67 3.85-14.49.1-28.99.17-43.48-.08-3.87-.07-4.62 1.15-4.61 4.76.14 34.46 0 68.92.19 103.38.02 4.33-.97 5.61-5.46 5.56-21.99-.25-43.98-.26-65.97 0-4.72.06-6.11-1-6.09-5.94.2-50.77.12-101.55.12-152.32Zm77.29-56.43c0 11.82.12 23.65-.08 35.47-.06 3.34 1.01 4.16 4.21 4.12 14.33-.19 28.66.11 42.99-.24 23.94-.59 37.22-13.69 38.47-37.46 1.21-22.96-10.35-37.66-33.19-40.7-16.54-2.2-33.28-.44-49.93-.86-3.07-.08-2.45 1.99-2.46 3.71-.02 11.99-.01 23.98-.02 35.97Zm1017.61 81.44c0 14.48-.02 28.97.01 43.45 0 2.66.08 5.33.34 7.98.86 8.84 5.48 13.89 14.27 15.47 10.58 1.9 21.28.77 31.91.81 3.85.02 4.67 1.12 4.64 4.77-.18 18.64-.18 37.29 0 55.93.03 3.66-.83 4.92-4.69 4.81-18.46-.56-37.02 1.22-55.39-1.51-25.71-3.81-47.57-13.98-59.58-38.84-6.64-13.75-8.71-28.6-8.83-43.66-.25-32.79-.18-65.59-.02-98.39.02-4.11-.92-5.44-5.16-5.22-7.14.37-14.33-.09-21.48.18-3.46.13-4.18-1.16-4.16-4.29.11-18.64.11-37.29 0-55.94-.02-3 .78-4.11 3.93-4.02 7.49.21 15-.12 22.49.15 3.63.13 4.39-1.17 4.36-4.54-.15-17.48.05-34.96-.16-52.44-.05-3.8 1.05-4.69 4.74-4.67 22.66.17 45.31.2 67.97-.02 4.14-.04 4.93 1.33 4.89 5.09-.18 15.81-.08 31.63-.08 47.44q0 9.05 9.31 9.05c12.33 0 24.66.1 36.98-.07 3.16-.04 4.27.69 4.24 4.08-.17 18.64-.16 37.29 0 55.93.03 3.23-.78 4.27-4.12 4.22-13.99-.18-27.99.03-41.98-.15-3.45-.05-4.54.87-4.5 4.42.18 16.65.08 33.29.08 49.94Zm477.7-33.58c0 53.78-.05 107.56.11 161.34.01 4.38-1.03 5.55-5.48 5.5-22.32-.25-44.65-.21-66.98-.02-3.94.03-4.95-1.05-4.95-4.97.11-108.06.11-216.12 0-324.17 0-3.71.89-4.8 4.68-4.77 22.49.17 44.99.2 67.48-.02 4.21-.04 5.24 1.15 5.23 5.27-.14 53.95-.09 107.89-.09 161.84Zm-1212.7-44.41c6.2-8.75 13.01-16.58 21.22-23.11 15.45-12.28 32.88-19.18 52.7-19.99 3.51-.14 4.48.85 4.46 4.37-.15 24.3-.15 48.61 0 72.91.02 3.58-1.13 4.44-4.55 4.44-11.14.02-22.3-.6-33.41 1.1-26.32 4.04-40.32 19-40.77 45.83-.63 37.78-.32 75.57-.41 113.36 0 3-.1 6 .03 8.99.1 2.33-.73 3.26-3.14 3.25-23.82-.06-47.65-.05-71.47-.01-2.11 0-3.1-.76-2.92-2.92.08-.99 0-2 0-3 0-79.91.05-159.82-.11-239.72 0-4.83 1.2-6.08 6.03-6.02 22.15.27 44.31.23 66.47.02 4.24-.04 5.33 1.22 5.21 5.32-.29 9.98-.12 19.97-.07 29.96 0 1.57-.49 3.24.73 5.21Zm1346.19 85.57c0 40.11-.06 80.22.09 120.34.02 4.06-.95 5.37-5.18 5.33-22.48-.21-44.97-.19-67.45-.01-3.88.03-5.05-.96-5.04-4.96.12-80.56.11-161.11.01-241.67 0-3.82.86-5.11 4.92-5.08 22.48.2 44.97.2 67.45 0 4.11-.04 5.31 1 5.29 5.22-.16 40.28-.1 80.56-.1 120.84Zm-39.09-152.25c-11.89.04-22.73-3.04-31.73-11.07-12.64-11.28-16.64-25.46-12.27-41.58 4.47-16.52 16.21-25.9 32.54-29.49 11.45-2.51 22.87-1.75 33.69 3.21 16.14 7.41 25.56 23.79 23.9 41.23-1.66 17.45-14.68 32.08-32.26 36.29-4.57 1.09-9.2 1.36-13.86 1.4ZM158.4 168.86c20.6.02 37.56 17.04 37.35 37.49-.21 20.38-16.93 37.04-37.29 37.16-20.54.12-37.47-16.75-37.46-37.36 0-20.73 16.63-37.31 37.41-37.29Z" class="cls-3"/>
                        <path d="M2414.64 84.03c-22.02-.02-37.64-16.21-37.65-39.02 0-23.14 15.59-39.12 38.07-39.01 21.85.1 37.68 16.67 37.51 39.26-.16 22.79-15.82 38.79-37.94 38.78Zm6.54-34.63c.94-.44 1.38-.69 1.84-.85 8.73-3.1 12.27-8.31 11.1-16.35-1.11-7.6-6.1-11.65-15.23-11.98-5.98-.22-11.97-.02-17.96-.11-2.04-.03-3.02.55-3.01 2.8.06 14.62.09 29.25-.02 43.88-.02 3.13 1.79 2.93 3.88 2.95 2.14.02 3.98.08 3.84-3-.18-4.15-.18-8.31.02-12.46.09-1.77-1.28-4.52 1.24-5.14 2.74-.67 5.72-.91 7.74 2.53 2.75 4.72 6.47 8.89 9.13 13.65 2.67 4.8 6.27 4.98 11.37 3.66-4.73-6.65-9.21-12.95-13.93-19.59Z" class="cls-1"/>
                        <path d="M2421.18 49.41c4.73 6.65 9.2 12.94 13.93 19.59-5.1 1.32-8.7 1.14-11.37-3.66-2.65-4.77-6.37-8.93-9.13-13.65-2.01-3.45-4.99-3.21-7.74-2.53-2.52.62-1.16 3.37-1.24 5.14-.2 4.15-.2 8.31-.02 12.46.14 3.08-1.7 3.02-3.84 3-2.09-.02-3.9.18-3.88-2.95.12-14.62.09-29.25.02-43.88 0-2.25.97-2.83 3.01-2.8 5.99.09 11.98-.1 17.96.11 9.13.33 14.12 4.38 15.23 11.98 1.17 8.03-2.37 13.25-11.1 16.35-.46.16-.9.41-1.84.85ZM2414.24 27q-8.66-.14-8.67 8.76c0 1.49.03 2.98 0 4.47-.03 1.6.58 2.51 2.3 2.44 4.29-.16 8.59.36 12.88-.4 4.59-.82 6.34-3.63 6.22-8.07-.12-4.48-2.79-6.52-6.79-7.14-1.94-.3-3.96-.05-5.95-.05Z" class="cls-3"/>
                        <path d="M2414.24 27c1.98 0 4.01-.25 5.95.05 4 .62 6.67 2.66 6.79 7.14.12 4.44-1.63 7.25-6.22 8.07-4.28.77-8.59.24-12.88.4-1.72.07-2.34-.84-2.3-2.44.03-1.49 0-2.98 0-4.47q0-8.91 8.67-8.76Z" class="cls-1"/>
                      </svg>
                    </div>
                    <div class="modal__header__version">
                        Version de l'application : 1.0.3
                    </div>
                    <div class="modal__header__uuid">
                        UUID : {{ deviceUUID }}
                    </div>
                    <div class="modal__header__close" v-tap v-on:click="closeModal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
                            <path fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="square" stroke-width="2" d="M2.25 31.746l29.5-29.492m0 29.492L2.25 2.254"/>
                        </svg>
                    </div>
                </div>
                <div class="modal__reset">
                    <div class="modal__reset__text">
                        En cas de défaillance ou sur demande du support technique, vous pouvez réinitialiser l’application en cliquant sur le bouton ci-dessous, attention, tous les questionnaires non synchronisés seront définitivement perdus.
                    </div>
                    <button class="modal-button modal__reset__button"  v-tap v-on:click="logout">
                        Réinitialiser l’application et effacer les données
                    </button>
                </div>
                <div class="modal__logout">
                    <div class="modal__logout__text">
                        Vous êtes connecté en tant qu’<b>{{ displayName }}</b> sur l’<b>{{ deviceName }}</b>
                    </div>
                    <button class="modal-button modal__logout__button" v-tap v-on:click="logout">
                        Déconnecter le compte {{ displayName }}
                    </button>
                </div>
            </div>
        </div>
        <notifications group="app" position="bottom right" classes="app-notifications" width="450">
            <template slot="body" slot-scope="props">
                <div class="app-notifications" :class="[props.classes, props.item.type]">
                    <svg v-if="props.item.type === 'error'" class="notification-icon" xmlns="http://www.w3.org/2000/svg"
                         width="128" height="128" viewBox="0 0 128 128">
                        <g fill="#FD502F" fill-rule="nonzero">
                            <path d="M109.253 18.747C97.158 6.653 81.104 0 64 0S30.842 6.653 18.747 18.747C6.653 30.842 0 46.896 0 64s6.653 33.158 18.747 45.253C30.842 121.347 46.896 128 64 128s33.158-6.653 45.253-18.747C121.347 97.158 128 81.104 128 64s-6.653-33.158-18.747-45.253zm-5.145 85.36c-10.72 10.721-24.97 16.62-40.108 16.62-15.138 0-29.387-5.899-40.108-16.62-22.114-22.114-22.114-58.1 0-80.215C34.612 13.172 48.862 7.272 64 7.272c15.138 0 29.387 5.9 40.108 16.62 22.114 22.115 22.114 58.101 0 80.216z"/>
                            <path d="M91.921 35.079a3.654 3.654 0 00-5.185 0L63.5 58.312 40.264 35.08a3.654 3.654 0 00-5.185 0 3.653 3.653 0 000 5.184l23.236 23.234L35.08 86.73a3.653 3.653 0 000 5.184A3.689 3.689 0 0037.658 93c.923 0 1.873-.353 2.579-1.086l23.236-23.233 23.236 23.233A3.689 3.689 0 0089.288 93c.95 0 1.873-.353 2.579-1.086a3.653 3.653 0 000-5.184L68.685 63.497 91.92 40.263a3.653 3.653 0 000-5.184z"/>
                        </g>
                    </svg>
                    <svg v-if="props.item.type === 'success'" class="notification-icon"
                         xmlns="http://www.w3.org/2000/svg" width="102" height="102" viewBox="0 0 102 102">
                        <path fill="#98E07C" fill-rule="nonzero"
                              d="M30.09 41.31l-7.14 7.14L45.9 71.4l51-51-7.14-7.14L45.9 57.12 30.09 41.31zM91.8 51c0 22.44-18.36 40.8-40.8 40.8-22.44 0-40.8-18.36-40.8-40.8 0-22.44 18.36-40.8 40.8-40.8 4.08 0 7.65.51 11.22 1.53l8.16-8.16C64.26 1.53 57.63 0 51 0 22.95 0 0 22.95 0 51s22.95 51 51 51 51-22.95 51-51H91.8z"/>
                    </svg>
                    <a class="notification-title">
                        {{props.item.title}}
                    </a>
                    <a class="close" v-tap @click="props.close">
                        <i class="fa fa-fw fa-close"></i>
                    </a>
                    <div class="notification-content" v-html="props.item.text">
                    </div>
                </div>
            </template>
        </notifications>
    </div>
</template>

<script>
    import Authentication from './components/Authentication.vue'
    import Dashboard from './components/Dashboard.vue'
    import {mapState} from 'vuex'
    import Vue from 'vue'

    export default {
        name: 'app',
        components: {
            Authentication,
            Dashboard
        },
        computed: {
            ...mapState({
                sessionToken: state => state.authentication.sessionToken,
                isAuthenticated: state => state.authentication.isAuthenticated,
                modalIsOpen: state => state.authentication.modalIsOpen,
                displayName: state => state.authentication.displayName,
                deviceName: state => state.authentication.deviceName,
                deviceUUID: state => state.authentication.deviceUUID
            })
        },
        methods: {
            closeModal: function () {
                this.$store.dispatch('authentication/closeModal');
            },
            logout: function () {
                this.$store.dispatch('authentication/logout');
            },
            setDeviceInfos: function () {
                this.$store.dispatch('authentication/setDeviceUUID', Vue.cordova.device.uuid);
            }
        },
        data() {
            return {
                device: null,
            }
        },
        mounted() {
            document.addEventListener("deviceready", this.setDeviceInfos, false);
        }
    }

</script>

<style lang="scss">
    body {
        background: #F5F7FB;
        padding: 0;
        margin: 0;
    }

    * {
        user-select: none;
        -moz-user-select: -moz-none;
        -khtml-user-select: none;
        -webkit-user-select: none;
        -webkit-user-callout: none;
    }

    input, textarea {
        -webkit-user-select: text;
        -webkit-user-callout: default;
        -webkit-touch-callout: default;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        height: 100%;
        padding-top: 73px;
    }

    .modal-button{
        appearance: none;
        display: block;
        width: 100%;
        border: none;
        background-color: #DF144C;
        color: white;
        font-family: inherit;
        font-size: 15px;
        padding: 13px 0;
        border-radius: 6px;
        font-weight: 600;
    }

    .modal {
        background-color: rgba(0, 0, 0, 0.6);
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        align-items: center;
        justify-content: center;
        z-index: 2500;
        transform: translateX(0);
        visibility: hidden;
        opacity: 0;
        display: flex;
        transition: all .3s ease-in-out;

        &__header{
            background: #F7F7F7;
            border-bottom: 1px solid #E8E8E8;
            padding: 25px 0 15px 0 ;
            position: relative;

            &__close{
                position: absolute;
                right: 20px;
                top: 20px;

                svg{
                    width: 20px;
                    height: 20px;
                }
            }

            &__logo{
                svg{
                    width: 190px;
                    height: 70px;
                }
            }

            &__version{
                font-size: 12px;
                font-weight: 500;
            }

            &__uuid{
                font-size: 12px;
            }
        }

        &__reset{
            padding: 25px;

            &__text{
                font-size: 14px;
                padding: 0 10px;
                color: black;
                margin-bottom: 15px;
            }

            &__button{
                background-color: #DF144C;
            }
        }

        &__logout{
            border-top: 1px solid #E2E2E2;
            padding: 25px 25px 35px 25px;

            &__text{
                margin-bottom: 15px;
                font-size: 14px;
                color: black;
            }

            &__button{
                background-color: #323232;
            }

        }

        &__content {
            background: white;
            width: 440px;
            border-radius: 3px;
            transition: all .4s ease-in-out;
            transition-delay: .1s;
            transform: translateY(30px);
            opacity: 0;
            overflow: hidden;
        }

        &.open {
            visibility: visible;
            opacity: 1;

            .modal__content {
                transform: translateY(0);
                opacity: 1;
            }
        }
    }


    .app-notifications {
        // Style of the notification itself
        font-size: 17px;
        margin-bottom: 20px;
        margin-right: 20px;
        padding: 25px;
        border-radius: 4px;
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(178, 178, 178, 0.50);
        text-align: left;

        .notification-title {
            // Style for title line
            font-size: 20px;
        }

        .notification-content {
            // Style for content
        }

        .notification-icon {
            float: left;
            width: 50px;
            height: 50px;
            margin-right: 15px;
        }

        &.warn {
            background: #ffb648;
            border-left-color: #f48a06;
        }

        &.error {
            .notification-title {
                color: #FD502F;
            }
        }

        &.success {
            .notification-title {
                color: #5fb117;
            }
        }
    }
</style>
